import React from 'react';
import { styled } from '@compiled/react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { Section, SkeletonItem } from '@atlaskit/side-navigation';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { SidebarSkeletonItemProps } from './types.tsx';

export const Skeleton = ({ isFull = false }: SidebarSkeletonItemProps) => (
	<UFOLoadHold name="sidebar-skeleton">
		<BackgroundedWrapper>
			{isFull && (
				<HeadingWrapper>
					<SkeletonItem hasIcon />
				</HeadingWrapper>
			)}
			<Section>
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
				<SkeletonItem hasIcon={isFull} />
			</Section>
		</BackgroundedWrapper>
	</UFOLoadHold>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BackgroundedWrapper = styled.div({
	height: 'calc(100% - 15vh)',
	paddingTop: 0,
	paddingRight: token('space.300'),
	paddingBottom: 0,
	paddingLeft: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeadingWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `${gridSize * 3 + gridSize / 2}px 0 ${token('space.200')}`,
});
